import { AxiosError } from 'axios'

import {
  BaseSubjectStore,
  GorillaResume,
  GorillaResumeMetrics,
  GorillaResumeScore,
} from '@procom-labs/common'


import { FeatureFlags, ITemplate, ResumeBuilderStateEnum } from '../models'

export interface IResumeBuilderStoreState {
  userEmail: string
  clientId: string
  templates: ITemplate[]
  template: ITemplate | null
  file: File | null
  originalResumeFileContent: string
  state: ResumeBuilderStateEnum
  resume: GorillaResume | null
  original: GorillaResume | null
  progress: string
  step: number
  metrics: GorillaResumeMetrics | null
  score: GorillaResumeScore | null
  error: string | AxiosError | null
  startTime: number
  importDate: Date | null
  isATSBullhorn: boolean
  featureFlags: FeatureFlags[]
  usageTracked: boolean
  taskId: string | null
}

export class ResumeBuilderStore extends BaseSubjectStore<IResumeBuilderStoreState> {
  getDefaultValue(): IResumeBuilderStoreState {
    return {
      userEmail: '',
      clientId: '',
      templates: [],
      template: null,
      file: null,
      originalResumeFileContent: '',
      state: ResumeBuilderStateEnum.NoFile,
      resume: null,
      original: null,
      metrics: null,
      score: null,
      error: null,
      progress: '',
      step: 0,
      startTime: 0,
      importDate: null,
      isATSBullhorn: false,
      featureFlags: [FeatureFlags.DynamicSections],
      usageTracked: false,
      taskId: null,
    }
  }

  resetResumeState(): void {
    this.dispatch({
      file: null,
      originalResumeFileContent: '',
      state: ResumeBuilderStateEnum.NoFile,
      resume: null,
      original: null,
      progress: '',
      metrics: null,
      score: null,
      error: null,
      startTime: 0,
      step: 0,
      usageTracked: false,
      taskId: null,
    })
  }
}

export const resumeBuilderStore = new ResumeBuilderStore()
